import Model from 'src/app/common/model';

export default class PersonRoleModel extends Model {
  name: string;
  code: string;
  description: string;
  businessType:Array<BusinessTypes>;

  constructor() {
    super();
  }
}
class BusinessTypes{
  businessTypeID:string;
  name:string;

  constructor(){

  }
}
